import { useAuth } from '@workos-inc/authkit-react';
import { api } from './client';

export function useProfile() {
  const { isLoading, user } = useAuth();

  const query = api.users.me.useQuery(undefined, {
    enabled: !isLoading && Boolean(user),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return query.data ?? null;
}

// Alternative implementation using suspense
export function useProfileWithSuspense() {
  const { isLoading, user } = useAuth();

  if (isLoading || !user) {
    return null;
  }

  // useSuspenseQuery will suspend until data is available
  // The parent component needs to wrap this in a Suspense boundary
  const [data] = api.users.me.useSuspenseQuery(undefined, {
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return data;
}
